<script>
// 这里直接复用 OpenAIDemo 的实现，保证 askInputDemo 和 OpenAIDemo 两个目录入口都可访问。
import OpenAIDemo from '../openai/index.vue'

export default OpenAIDemo
</script>
